import Script from "next/script";
import React, { FC } from "react";

interface Props {
  GTAG_ID?: string;
}

export const Scripts: FC<Props> = ({ GTAG_ID }) => {
  return (
    <>
      <Script
        strategy={"afterInteractive"}
        src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`}
      />

      <Script id="guid" strategy={"afterInteractive"}>
        {`
              function guid() {
                return (
                  new Date().getTime() + "." + Math.random().toString(36).substring(5)
                );
              }
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag("js", new Date());
              gtag("set", { sessionId: guid() });
              gtag("config", "${GTAG_ID}");
          `}
      </Script>
    </>
  );
};
